import { client, ClientMethodsTypes } from '@/services/v2/client'
import { useMutation } from '@tanstack/react-query'

import { useEffect, useState } from 'react'
import { useUser } from 'containers/user/hooks/useUser'
import { useIsOwnProfile } from 'containers/profile/hooks/useProfile'
import {
  HighlightVieRequestParams,
  HighlightViewDTO,
} from '../types/highlights'

const apiUrl = `/api/v1/users`

export const useViewHighlight = (mutationKeys?: string[]) => {
  return useMutation({
    mutationFn: async (data: HighlightViewDTO) =>
      await client(`${apiUrl}/highlight/view-highlight`, {
        method: ClientMethodsTypes.POST,
        body: data,
      }),
    mutationKey: mutationKeys,
  })
}

export const useViewPHighlightRequest = (params: HighlightVieRequestParams) => {
  const { ownerProfile, highlight, detailView } = params
  const [wasSent, setWasSent] = useState(false)

  const { user } = useUser()
  const isOwnProfile = useIsOwnProfile()

  const { mutateAsync } = useViewHighlight([
    'Highlight-view',
    highlight?.id,
    ownerProfile?.id,
    user?.id,
    detailView ? 'detail' : 'list',
  ])

  useEffect(() => {
    if (
      ownerProfile?.id &&
      !isOwnProfile &&
      highlight?.id &&
      (!wasSent || detailView)
    ) {
      setWasSent(true)
      mutateAsync({
        highlightId: highlight?.id,
        highlightOwnerId: ownerProfile?.id,
        viewerId: user?.id,
        detailView,
      })
    }
  }, [
    detailView,
    isOwnProfile,
    mutateAsync,
    ownerProfile?.id,
    highlight?.id,
    user?.id,
    wasSent,
  ])
}
